import ListIncreaseReasons from './views/List.vue'

export const IncreaseReasonsRoutes = [
  {
    path: '/increase-reasons',
    name: 'ListIncreaseReasons',
    component: ListIncreaseReasons,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'increase_reason:list'
    }
  }
]
